
import React from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Mail, Share, MessageSquare } from 'lucide-react';
import { AtheismResponse } from '@/components/AtheismDefense/types';
import { shareViaEmail, shareViaSMS, shareToFacebook } from '@/components/AtheismDefense/utils/shareUtils';

interface ResponseActionsProps {
  question: string;
  response: AtheismResponse;
  toolType: string;
}

export const ResponseActions: React.FC<ResponseActionsProps> = ({ question, response, toolType }) => {
  const handleShareViaEmail = () => {
    if (toolType === 'atheism_defense') {
      shareViaEmail(question, response);
    }
  };

  const handleShareViaSMS = () => {
    if (toolType === 'atheism_defense') {
      shareViaSMS(question, response);
    }
  };

  const handleShareToFacebook = () => {
    shareToFacebook();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="flex-1">
          <Share className="h-4 w-4 mr-2" />
          Share
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={handleShareViaEmail}>
          <Mail className="h-4 w-4 mr-2" /> Share via Email
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleShareViaSMS}>
          <MessageSquare className="h-4 w-4 mr-2" /> Share via SMS
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleShareToFacebook}>
          <svg
            className="h-4 w-4 mr-2 text-facebook"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="#1877F2"
          >
            <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C15.9 21.59 18.04 20.44 19.65 18.73C21.26 17.03 22.23 14.84 22.24 12.56C22.24 6.53 17.73 2.04 12 2.04Z" />
          </svg>
          Share to Facebook
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
